// DEPENDENCIES //
import { createOffspring } from "../../utils/api";
import axios from "axios";
import React, { useState } from "react"
import { useNavigate } from "react-router-dom";
import { ReactDOM } from "react";

// COMPONENTS //
import WakeButton from "../../components/WakeButton";
import BrushButton from "../../components/BrushButton";
import Borders from "../../components/Borders";

// IMAGES //
import borderPage from "../../assets/border_page.png";

// STYLES //
import "./createZombie.css"

// LOCATIONS //
const locations = [
    "San Giorgio",
    "Negrar",
    "Parona",
    "Verona"
];

const clothingColors = [
    "venetian_red",
    "burnt_sienna",
    "yellow_ochre",
    "raw_umber",
    "olive_green",
    "viridian",
    "ultramarine",
    "cerulean",
    "naples_yellow",
    "terre_verte"
];

export default function CreateZombie({ zombie, setZombie, stopMusic }) {

    // STATE //
    const [formState, setFormState] = useState({})
    const navigate = useNavigate()

    const handleSubmit = (event) => {
        event.preventDefault();

        const randomClothingColor = clothingColors[Math.floor(Math.random() * clothingColors.length)];

        const trimmedName = formState.name.trim();

        if (!trimmedName) {
            return;
        }

        const zombieData = {
            ...formState,
            name: trimmedName,
            clothing_color: randomClothingColor
        };

        createOffspring(zombieData).then(data => {
            setZombie(data);
            localStorage.setItem("currentZombieId", data._id);
            navigate("/showZombie");
        });
    };

    function handleChange(event) {
        setFormState({ ...formState, [event.target.id]: event.target.value })
    };

    return (

        <div className="game-page create-zombie-page">
            <Borders image={borderPage} scale={0.98} />

            <h1 className="game-title">LONTANO DAGLI OCCHI, LONTANO DAL CUORE</h1>

            <form
                id="create-zombie-form"
                onSubmit={handleSubmit}
                className="create-zombie-form"
            >
                <section className="create-zombie-copy">
                    <p>Now, you may have heard the warnings. Some strange sickness. A town gone quiet. Livestock disappearing. Folks locking their doors before sunset. But that's somebody else's problem. You have more important things on your mind…like making a baby! A cute one, if possible.</p>
                </section>

                <div className="form-column">
                    <div className="form-field">
                        <label htmlFor="name" className="sr-only">
                            Baby's Name
                        </label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Baby's Name"
                            onChange={handleChange}
                            value={formState.name || ""}
                            maxLength={16}
                            required
                        />
                    </div>

                        <div className="form-field">
                        <label htmlFor="birthplace" className="sr-only">
                            Birthplace
                        </label>

                        <select
                            id="birthplace"
                            onChange={handleChange}
                            value={formState.birthplace || ""}
                            required
                        >
                            <option value="" disabled>Birthplace</option>

                            {locations.map((birthplace) => (
                                <option key={birthplace} value={birthplace}>
                                    {birthplace}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-field">
                        <label htmlFor="complexion" className="sr-only">
                            Baby's Complexion
                        </label>
                        <select
                            id="complexion"
                            onChange={handleChange}
                            value={formState.complexion || ""}
                            required
                        >
                            <option value="">Complexion</option>

                            <option value="alabaster">Alabaster</option>

                            <option value="ivory">Ivory</option>

                            <option value="ochre">Ochre</option>

                            <option value="sienna">Sienna</option>

                            <option value="umber">Umber</option>

                            <option value="sepia">Sepia</option>
                        </select>
                    </div>
                </div>

                <div className="form-column">
                    <div className="form-field">
                        <label htmlFor="eye_color" className="sr-only">
                            Baby's Eye Color
                        </label>
                        <select
                            id="eye_color"
                            onChange={handleChange}
                            value={formState.eye_color || ""}
                            required
                        >
                            <option value="">Eye Color</option>

                            <option value="amber">Amber</option>

                            <option value="azure">Azure</option>

                            <option value="walnut">Walnut</option>

                            <option value="slate">Slate</option>

                            <option value="emerald">Emerald</option>

                            <option value="hazel">Hazel</option>
                        </select>
                    </div>

                    <div className="form-field">
                        <label htmlFor="hair_color" className="sr-only">
                            Baby's Hair Color
                        </label>
                        <select
                            id="hair_color"
                            onChange={handleChange}
                            value={formState.hair_color || ""}
                            required
                        >
                            <option value="">Hair Color</option>

                            <option value="ash">Ash</option>

                            <option value="chestnut">Chestnut</option>

                            <option value="copper">Copper</option>

                            <option value="mahogany">Mahogany</option>

                            <option value="golden">Golden</option>

                            <option value="raven">Raven</option>
                        </select>
                    </div>

                    <div className="form-field">
                        <label htmlFor="appetite" className="sr-only">
                            Baby's Appetite
                        </label>
                        <select
                            id="appetite"
                            onChange={handleChange}
                            value={formState.appetite || ""}
                            required
                        >
                            <option value="">Appetite</option>

                            <option value="picky_eater">Picky</option>

                            <option value="always_hungry">Always Hungry</option>

                            <option value="ravenous">Ravenous</option>
                        </select>
                    </div>
                </div>

                <div className="create-zombie-actions">
                    {/* <button
                        type="submit"
                        className="game-button zombie-button"
                    >
                        Have a Baby
                    </button> */}
                    <BrushButton
                        type="submit"
                        className="zombie-button"
                    >
                        Have a Baby
                    </BrushButton>

                    <WakeButton
                        zombie={zombie}
                        setZombie={setZombie}
                        stopMusic={stopMusic}
                    />
                </div>

            </form>
        </div>
    )
}

